export default __webpack_public_path__ + "static/media/star.53e05c12.svg";